import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';

import {
  AssetCard,
  Button,
  Input,
  Select,
  GridView,
  AssetListCard,
  LoaderComponent,
} from 'components/common';
import AssetCardImg from 'assets/images/asset-card.svg';
// import { axiosData } from 'services/fetchInterceptor';
import { useAccount } from 'wagmi';
import { axiosData } from 'services/axiosData';

const MyAssets = () => {
  const assets: any = [];

  const setOpen = () => {};

  const [activeGrid, setActiveGrid] = useState<string>('grid');

  const [properties, setProperties] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { address } = useAccount();

  useEffect(() => {
    setLoading(true);

    if (!address) {
      alert('Please connect wallet');
    }

    axiosData
      .get(`/property/listed/${address}`)
      .then((response) => {
        console.log(response);

        setProperties(response);
      })
      .catch((err) => {
        console.log('err', err);
      })
      .then(() => {
        setLoading(false);
      });
    console.log(properties);
  }, []);

  return (
    <div>
      {loading && <LoaderComponent />}
      <div className="flex justify-between flex-col sm:flex-row">
        <Formik initialValues={{ searchParams: '' }} onSubmit={() => setOpen()}>
          <Form>
            <Input
              className="bg-transparent border border-primary-2 outline-0 py-2 rounded-2xl text-white xl:min-w-[300px] xl:min-w-[456px] px-4"
              placeholder="Search lands, apartments and buildings"
            />
          </Form>
        </Formik>

        <Formik initialValues={{ sortBy: '' }} onSubmit={() => setOpen()}>
          <Form className="mt-4 sm:mt-0">
            <Select
              placeholder="Sort by"
              className="bg-transparent border border-primary-2 py-2 px-3 rounded-2xl min-w-[230px] focus:outline-none text-white"
              type="select"
              name="sortBy"
            >
              <option value="name">Name</option>
              <option value="date">Date</option>
            </Select>
          </Form>
        </Formik>
      </div>

      <div className="flex justify-end">
        <GridView setActiveGrid={setActiveGrid} activeGrid={activeGrid} />
      </div>

      {activeGrid === 'grid' ? (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12">
          {properties?.map((ppty: any) => (
            <AssetCard
              key={ppty.propertyId}
              propertyId={ppty.propertyId}
              propertySlug={ppty.slug}
              img={ppty.primaryImage}
              title={ppty.title}
              description={ppty.description}
              address={ppty.address}
              favourite={false}
            />
          ))}
        </div>
      ) : (
        <>
          <div className="grid grid-cols-ourTable gap-3 py-4 border-y border-white/20">
            <p className="text-white text-xl">Assets</p>
            <p className="text-white text-xl">Description</p>
            <p className="text-white text-xl">Listed Price</p>
            <p>.</p>
          </div>
          {properties.map((ppty: any) => (
            <AssetListCard
              key={ppty.propertyId}
              propertyId={ppty.propertyId}
              propertySlug={ppty.slug}
              img={ppty.primaryImage}
              title={ppty.title}
              description={ppty.description}
              address={ppty.address}
              favourite={false}
            />
          ))}
        </>
      )}

      <div className="flex justify-center mt-12">
        <Button type="button" variant="primary">
          View More
        </Button>
      </div>
    </div>
  );
};

export default MyAssets;
